<template>
  <div class="dashboard graficos">

    <div class="row topCardGrid">
      <sp-card :valor="cardsData.empregos_municipio" :descricao="$t('emprego.cardTotalMunicipio')" placement="bottom"
        :tooltip="$t('emprego.tooltipMunicipio')" :lgGrid="3" :footerText="$t('rodape.estimativa', {fonte: metadados.cards.fonte, data: metadados.cards.data})"></sp-card>
      <sp-card :valor="cardsData.empregos_micro_regiao" tooltipClasses="customTooltip"
        :valorProgressBar="cardsData.porcentagem_micro_regiao" :descricao="$t('emprego.cardTotalMicroRegiao')"
        :tooltip="$t('emprego.tooltipMicroRegiao')" :lgGrid="3"
        :footerText="$t('rodape.estimativa', {fonte: metadados.cards.fonte, data: metadados.cards.data})"></sp-card>
      <sp-card :valor="cardsData.empregos_uf" :valorProgressBar="cardsData.porcentagem_uf"
        :descricao="$t('emprego.cardTotalUF')" :tooltip="$t('emprego.tooltipEstado')" :lgGrid="3"
        :footerText="$t('rodape.estimativa', {fonte: metadados.cards.fonte, data: metadados.cards.data})"></sp-card>
      <sp-card :valor="cardsData.empregos_brasil" :valorProgressBar="cardsData.porcentagem_brasil"
        :descricao="$t('emprego.cardTotalBrasil')" :tooltip="$t('emprego.tooltipBrasil')" :lgGrid="3"
        :footerText="$t('rodape.estimativa', {fonte: metadados.cards.fonte, data: metadados.cards.data})"></sp-card>
    </div>

    <div class="row">
      <div class="flex lg12 md12 xs12">
        <sp-360-panel
          :title="$t('emprego.lineAdmissaoDesligamento')"
          :tooltipOptions="tooltipLineHistorico"
          :footerText="periodicidadeDisclaimer">
          <sp360-chart :data="dataLineHistorico" type="line" class="chart" :options="optionsLineHistorico" />
        </sp-360-panel>
      </div>
    </div>

    <div class="row">
      <div class="flex lg12 md12 xs12">
        <sp-360-panel
          :title="$t('emprego.lineAdmissaoSetor')"
          :tooltipOptions="tooltipBarSetor"
          :footerText="periodicidadeDisclaimer">
          <sp360-chart :data="dataLineSetor" type="line" class="chart" :options="optionsLineSetor" />
        </sp-360-panel>
      </div>
    </div>

    <div class="row">
      <div class="flex lg12 md12 xs12">
        <sp-360-panel
          :title="tituloBarSetor"
          :tooltipOptions="tooltipBarSetor"
          :footerText="periodicidadeDisclaimer">
          <sp360-chart v-bind:data="dataBarAnoSetor" :options="optionsBarSetor" type="horizontal-bar" class="chart" />
        </sp-360-panel>
      </div>
    </div>

    <div class="row">
      <div class="flex lg12 md12 xs12">
        <sp-360-panel  :title="tituloBarSetor" :footerText="$t('emprego.disclaimer')">
          <div id="tabelaAdmissoesPorSetor">
            <sp360-data-table id="tabelaSetor" ref="tabelaSetor" :apiMode="false" :data="tableDataPorSetor.data"
              :fields="tableFieldsPorSetor" :perPage="itemsPerPagePorSetor" :sortFunctions="sortFunctionsPorSetor"
              :title="tituloTableSetor" />
          </div>
        </sp-360-panel>
      </div>
    </div>

  <!-- <div class="row">
    <div class="flex lg12 md12 xs12">
      <sp-360-panel>
        <span class="disclaimer">
          {{$t('emprego.disclaimer')}}
        </span>
      </sp-360-panel>
    </div>
  </div> -->

  </div>
</template>

<script>
import SpMap from '@/components/maps/360-maps/SPMap.vue'
import _ from 'lodash'
import MetodosGlob from '@/utils/MetodosGlobais'
import CorUtils from '@/utils/CorUtils'
import GraficoPiramide from '@/components/statistics/charts/GraficoPiramide'
import SpCard from '@/components/ui/cards/SP360Card'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'

export default {
  name: 'dados-empregaticios',
  components: {
    SpMap,
    SpCard,
    GraficoPiramide,
    Sp360Chart,
    Sp360Panel,
    Sp360DataTable,
  },
  data () {
    return {
      metadados: {
        cards: {
          fonte: '',
          data: '',
        },
        graficos: {
          fonte: '',
          data: '',
        },
      },
      periodicidadeDisclaimer: '',
      separadorMilharOption: {
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.labels[tooltipItem.index] || ''
              if (label) {
                label += ': '
              }
              label += MetodosGlob.thousandSeparator(data.datasets[0].data[tooltipItem.index])
              return label
            },
          },
        },
      },
      tituloBarSetor: '',
      tituloTableSetor: '',
      cardsData: {},
      dataLineHistorico: {},
      dataLineSetor: {},
      dataDonutAdmissao: {},
      dataDonutDesligamento: {},
      dataBarSetor: {},
      dataAnoBarSetor: {},
      optionsLineHistorico: {},
      optionsLineSetor: {},
      optionsBarSetor: {
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 20,
            bottom: 0,
          },
        },
        plugins: {
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            // formatter: (value) => this.formatarPorcentagem(value),
            anchor: 'end',
            align: 'end',
            display: 'auto',
            formatter: (value) => MetodosGlob.thousandSeparator(value),
            font: {
              weight: 'bold',
            },
          },
        },
        tooltips: {
          enabled: true,
          callbacks: MetodosGlob.percentualLabelCallback(false, true, 'pie'),
        },
        scales: {
          xAxes: [{
            ticks: {
              autoSkip: false,
              maxRotation: 30,
            },
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('emprego.barSetorEixoX'),
            },
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('emprego.barSetorEixoY'),
            },
          }],
        },
      },
      tooltipLineHistorico: {},
      tooltipLineSetor: {},
      tooltipBarSetor: {},
      tooltipDonutAdmissao: {},
      tooltipDonutDesligamento: {},
      dataBarAnoSetor: {},
      tableDataPorSetor: {
        'data': [],
      },
      tableFieldsPorSetor: [{
        name: 'setor',
        title: this.$t('emprego.tableSetorSetor'),
        // width:'50%'
      },
      {
        name: 'admissoes_municipio',
        sortField: 'admissoes_municipio',
        title: this.$t('emprego.tableSetorAdmissoes'),
        callback: MetodosGlob.thousandSeparator,
      },
      {
        name: 'desligamentos_municipio',
        sortField: 'desligamentos_municipio',
        title: this.$t('emprego.tableSetorDesligamento'),
        callback: MetodosGlob.thousandSeparator,
      },
      {
        name: 'empregos_municipio',
        sortField: 'empregos_municipio',
        title: this.$t('emprego.tableSetorEmprego'),
        callback: MetodosGlob.thousandSeparator,
      },
      {
        name: 'saldo',
        sortField: 'saldo',
        title: this.$t('emprego.tableSetorSaldo'),
        callback: MetodosGlob.thousandSeparator,
      },
      ],
      itemsPerPagePorSetor: 10,
      sortFunctionsPorSetor: {},
      cores: _.shuffle(CorUtils.getVetorCoresPorTom('medio')),
      progressKey: 1,
    }
  },
  created () {
    Promise.all([
      this.$store.dispatch('populacao/historicoAdmissaoDesligamento', { ultimosMeses: 13 }),
      this.$store.dispatch('populacao/historicoAdmissaoPorSetor', { ultimosMeses: 13 }),
      this.$store.dispatch('populacao/admissaoDesligamentoPorSetor'),
      this.$store.dispatch('populacao/totalAdmissaoPorRegiaoMacroMicro'),
    ])
      .then(
        (respostas) => {
          this.fonte = respostas[0].data.sigla_orgao + '-' + respostas[0].data.fonte
          this.dataRef = new Date(respostas[0].data.data_referencia_dado).toLocaleDateString('pt-BR')
          this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })

          this.metadados.cards.fonte = respostas[0].data.sigla_orgao
          this.metadados.cards.data = respostas[0].data.data_referencia_dado

          let admissaoDesligamento = this.populateLineAdmissaoDesligamento(respostas[0].data.data, 'emprego.admissoesDesligamentoEixoX', 'emprego.admissoesDesligamentoEixoY')
          this.dataLineHistorico = admissaoDesligamento.chartData
          this.optionsLineHistorico = admissaoDesligamento.options

          let admissaoSetor = this.populateLineAdmissaoSetor(respostas[1].data.data, 'emprego.admissoesSetorEixoX', 'emprego.admissoesSetorEixoY')
          this.dataLineSetor = admissaoSetor.chartData
          this.optionsLineSetor = admissaoSetor.options
          this.populateTableSetor(respostas[2].data.data)

          let barAnoSetor = this.populateBarAnoSetores(respostas[1].data.data, 'emprego.admissoesSetorEixoX', 'emprego.admissoesSetorEixoY')
          this.dataBarAnoSetor = barAnoSetor.chartData

          let d = respostas[1].data.data.slice(-1)[0]
          let periodo = MetodosGlob.mapeiaMesAbreviacao(parseInt(d.mes)).abrev + '/' + d.ano
          this.periodicidadeDisclaimer = this.$t('emprego.periodicidadeDisclaimer') + periodo

          this.cardsData = this.populateCards(respostas[3].data.data)
          this.forceReRenderCards()
        }
      )
      .catch(
        (error) => {
          console.error(error)
        })
  },
  methods: {
    formatarNumeros (num, adicional = '') {
      return MetodosGlob.thousandSeparator(num) + adicional
    },

    formatarPorcentagem (num, casasDecimais = 2) {
      return num.toFixed(casasDecimais) + '%'
    },

    tooltipsCallback (perc, separadorMilhar) {
      return {
        label: function (tooltipItem, data) {
          var label = data.datasets[tooltipItem.datasetIndex].label + ': ' || ''
          if (separadorMilhar) { label += MetodosGlob.thousandSeparator(tooltipItem.yLabel) } else { label += tooltipItem.yLabel }
          if (label && perc) {
            label += '%'
          }
          return label
        },
      }
    },

    forceReRenderCards () {
    },

    populateCards (d) {
      let data = {}
      data.empregos_brasil = d.empregos_brasil
      data.empregos_micro_regiao = d.empregos_micro_regiao
      data.empregos_municipio = d.empregos_municipio
      data.empregos_uf = d.empregos_uf
      data.porcentagem_micro_regiao = parseInt(d.empregos_municipio / d.empregos_micro_regiao * 100)
      data.porcentagem_uf = parseInt(d.empregos_municipio / d.empregos_uf * 100)
      data.porcentagem_brasil = parseInt(d.empregos_municipio / d.empregos_brasil * 100)
      return data
    },

    populateTableSetor (d) {
      this.tituloTableSetor = this.$t('emprego.tituloTabelaSetor') + MetodosGlob.mapeiaMesAbreviacao(parseInt(d[0].mes)).abrev + '/' + d[0].ano
      this.sortFunctionsPorSetor = {
        'admissoes_municipio': MetodosGlob.ordenaTabela,
        'desligamentos_municipio': MetodosGlob.ordenaTabela,
        'saldo': MetodosGlob.ordenaTabelaParseInt,
      }

      let dados = []
      _.forEach(d, (setor) => {
        let n = {}
        n.setor = setor.setor
        n.admissoes_municipio = setor.admissoes_municipio
        n.desligamentos_municipio = setor.desligamentos_municipio
        n.empregos_municipio = setor.empregos_municipio
        n.saldo = setor.admissoes_municipio - setor.desligamentos_municipio
        dados.push(n)
      })
      dados = _.orderBy(dados, 'saldo', 'desc')
      this.$set(this.tableDataPorSetor, 'data', dados)
      // this.$refs.tabelaSetor.update()
    },

    populateLineAdmissaoDesligamento (d, legendaX, legendaY) {
      this.tooltipLineHistorico = {
        content: this.$t('emprego.tooltipAdmissaoDesligamento'),
        placement: 'bottom',
      }
      let chartData = {}
      let options = {}
      let datasets = []
      let cores = _.cloneDeep(this.cores)
      let Labels = ''

      Labels = _.map(d, (n) => {
        return new Date(n.ano, n.mes - 1).getTime()
      })

      let admissoesT = _.map(d, (n) => {
        return {
          y: n.admissoes_municipio,
          x: new Date(n.ano, n.mes - 1),
        }
      })

      let desligamentosT = _.map(d, (n) => {
        return {
          y: n.desligamentos_municipio,
          x: new Date(n.ano, n.mes - 1),
        }
      })

      let admissoes = _.map(d, (n) => {
        return n.admissoes_municipio
      })

      let desligamentos = _.map(d, (n) => {
        return n.desligamentos_municipio
      })

      let corDataset = ''
      let corAdm = CorUtils.getCorPorNomeSp360('verde-limao-medio')
      let corDes = CorUtils.getCorPorNomeSp360('vermelho-medio')

      let corTrendAdm = CorUtils.getCorPorNomeSp360('verde-limao-escuro')
      let corTrendDes = CorUtils.getCorPorNomeSp360('vermelho-escuro')

      let datasetAdmissoes = {
        label: this.$t('emprego.admissoes'),
        fill: false,
        backgroundColor: corAdm,
        borderColor: corAdm,
        data: (admissoes),
        yAxisID: 'y-axis-1',
      }

      let datasetDesligamentos = {
        label: this.$t('emprego.desligamentos'),
        fill: false,
        backgroundColor: corDes,
        borderColor: corDes,
        data: desligamentos,
        yAxisID: 'y-axis-1',
      }

      let deltaEmprego = []
      for (let index = 0; index < admissoesT.length; index++) {
        deltaEmprego.push(admissoesT[index].y - desligamentosT[index].y)
      }

      let trendAdmissoes = MetodosGlob.findLineByLeastSquares(Labels, // deltaEmprego
        _.map(admissoesT, (n) => {
          return n.y
        })
      )

      let trendDesligamentos = MetodosGlob.findLineByLeastSquares(Labels, // deltaEmprego
        _.map(desligamentosT, (n) => {
          return n.y
        })
      )

      let datasetVariacao = {
        label: 'trendline delta',
        fill: false,
        backgroundColor: '#00F',
        borderColor: '#00F',
        data: deltaEmprego,
        yAxisID: 'y-axis-1',
        pointRadius: 0,
      }

      corDataset = cores.shift()
      let datasetTrendAdmissoes = {
        label: 'Tendencia Admissões',
        fill: false,
        backgroundColor: corTrendAdm,
        borderColor: corTrendAdm,
        data: [],
        yAxisID: 'y-axis-1',
        borderDash: [10, 5],
        pointRadius: 0,
      }

      for (let index = 0; index < trendAdmissoes[0].length; index++) {
        let a = trendAdmissoes[1][index]

        datasetTrendAdmissoes.data.push(a)
      }

      corDataset = cores.shift()
      let datasetTrendDesligamentos = {
        label: 'Tendencia Desligamentos',
        fill: false,
        backgroundColor: corTrendDes,
        borderColor: corTrendDes,
        data: [],
        yAxisID: 'y-axis-1',
        borderDash: [10, 5],
        pointRadius: 0,

      }

      for (let index = 0; index < trendDesligamentos[0].length; index++) {
        let a = trendDesligamentos[1][index]
        datasetTrendDesligamentos.data.push(a)
      }

      datasets.push(datasetAdmissoes)
      datasets.push(datasetDesligamentos)
      datasets.push(datasetTrendAdmissoes)
      datasets.push(datasetTrendDesligamentos)

      let LabelsTrue = _.map(d, (r) => {
        return MetodosGlob.mapeiaMesAbreviacao(parseInt(r.mes)).abrev + '/' + r.ano
      })

      chartData = {
        datasets: datasets,
        labels: LabelsTrue,
      }

      options = this.getOptionsLine(legendaX, legendaY, false, true)

      // options.scales.xAxes[0].type = 'time'
      // options.scales.xAxes[0].time = {
      //  unit: 'month',
      // }

      return {
        chartData,
        options,
      }
    },

    populateLineAdmissaoSetor (dados, legendaX, legendaY) {
      this.tooltipLineSetor = { content: this.$t('emprego.tooltipAdmissaoSetor'), placement: 'bottom' }
      let chartData = {}
      let options = {}
      let datasets = []
      let cores = _.cloneDeep(this.cores)
      let Labels = ''

      let vetorSetores = _.groupBy(dados, 'setor')
      _.forEach(vetorSetores, d => {
        Labels = _.map(d, (r) => {
          return MetodosGlob.mapeiaMesAbreviacao(parseInt(r.mes)).abrev + '/' + r.ano
        })

        let admissoes = _.map(d, (n) => {
          return n.admissoes_municipio
        })

        let corDataset = cores.shift()
        let datasetAdmissoes = {
          label: d[0].setor,
          fill: false,
          backgroundColor: corDataset,
          borderColor: corDataset,
          data: admissoes,
          yAxisID: 'y-axis-1',
        }
        corDataset = cores.shift()
        datasets.push(datasetAdmissoes)
      })

      chartData = {
        datasets: datasets,
        labels: Labels,
      }

      options = this.getOptionsLine(legendaX, legendaY, false, true)

      return {
        chartData,
        options,
      }
    },

    populateDonutCharts (d, legendaX, legendaY) {
      this.tooltipLineHistorico = { content: this.$t('emprego.tooltipAdmissaoDesligamento'), placement: 'bottom' }
      let chartDataAdmissoes = {}
      let chartDataDesligamentos = {}
      let datasetsAdmissoes = []
      let datasetsDesligamentos = []
      let cores = _.cloneDeep(this.cores)

      let Labels = ''

      Labels = _.map(d, (r) => {
        return r.setor
      })

      let admissoes = _.map(d, (n) => {
        return n.admissoes_municipio
      })

      let desligamentos = _.map(d, (n) => {
        return n.desligamentos_municipio
      })

      let corDataset = []

      for (let i = 0; i < admissoes.length; i++) {
        corDataset.push(cores.shift())
      }
      let datasetAdmissoes = {
        label: this.$t('emprego.admissoes'),
        fill: false,
        backgroundColor: corDataset,
        data: admissoes,
      }

      let datasetDesligamentos = {
        label: this.$t('emprego.desligamentos'),
        fill: false,
        backgroundColor: corDataset,
        data: desligamentos,
      }

      datasetsAdmissoes.push(datasetAdmissoes)
      datasetsDesligamentos.push(datasetDesligamentos)

      chartDataAdmissoes = {
        datasets: datasetsAdmissoes,
        labels: Labels,
      }

      chartDataDesligamentos = {
        datasets: datasetsDesligamentos,
        labels: Labels,
      }

      return [chartDataAdmissoes, chartDataDesligamentos]
    },

    populateBarAnoSetores (d, legendaX, legendaY) {
      this.tooltipBarSetor = { content: this.$t('emprego.tooltipMensalPorSetor'), placement: 'bottom' }
      this.tituloBarSetor = this.$t('emprego.tituloWidgetSetor')
      let chartData = {}
      let options = {}
      let datasets = []
      let cores = _.cloneDeep(this.cores)
      let Labels = ''
      let maxLength = 20

      let pastMonth = d[0].mes
      let pastYear = d[0].ano
      let currentMonth = d[d.length - 1].mes
      let currentYear = d[d.length - 1].ano

      let data = {}

      d = _.orderBy(d, 'admissoes_municipio', 'desc')

      d.forEach(element => {
        if (!data[element.setor]) {
          data[element.setor] = {}
        }

        if ((element.mes == pastMonth) && (element.ano == pastYear)) {
          data[element.setor].past = element.admissoes_municipio
        } else if ((element.mes == currentMonth) && (element.ano == currentYear)) {
          data[element.setor].current = element.admissoes_municipio
        }
      })

      Labels = Object.keys(data)

      let arrayData = Object.values(data)
      let past = []
      let current = []
      let others = { current: 0, past: 0 }
      let removeCount = 0

      for (let i = 0; i < arrayData.length; i++) {
        let obj = arrayData[i]
        if (obj.past < 1000 && obj.current < 1000) {
          others.past += obj.past
          others.current += obj.current
          Labels.splice(i - removeCount++, 1)
        } else {
          current.push(obj.current)
          past.push(obj.past)
        }
      }

      if (others.current > 0 && others.past > 0) {
        Labels.push('Outros')
        past.push(others.past)
        current.push(others.current)
      }

      let corDataset = CorUtils.getCorPorNomeSp360('azul-medio')
      let datasetCurrent = {
        label: this.$t(MetodosGlob.mapeiaMesAbreviacao(parseInt(currentMonth)).abrev + '/' + currentYear),
        backgroundColor: corDataset,
        data: current,
      }

      corDataset = CorUtils.getCorPorNomeSp360('amarelo-medio')
      let datasetPast = {
        label: this.$t(MetodosGlob.mapeiaMesAbreviacao(parseInt(pastMonth)).abrev + '/' + pastYear),
        backgroundColor: corDataset,
        data: past,
      }

      datasets.push(datasetPast)
      datasets.push(datasetCurrent)

      chartData = {
        datasets: datasets,
        labels: Labels,
      }

      options = this.getOptionsLine(legendaX, legendaY, false, true)

      return {
        chartData,
        options,
      }
    },

    getOptionsLine (legendaX, legendaY, percentual = true, milhar = false) {
      return {
        // maintainAspectRatio: false,
        // aspectRatio: '16:9',

        tooltips: {
          intersect: true,
          callbacks: this.tooltipsCallback(percentual, milhar),
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaX || 'LegendaX'),
            },
          }],
          yAxes: [{
            ticks: {
              callback: (value) => MetodosGlob.thousandSeparator(value),
            },
            id: 'y-axis-1',
            type: 'linear',
            position: 'left',
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaY || 'LegendaY'),
            },
          }],
        },
      }
    },

  },
}

</script>

<style lang="scss" scoped>
.va-chart {
  max-height:30rem ;
}

.boldness{
    font-size: 2.5vw;
    font-weight: 900;
    @include media-breakpoint-down(md) {
      font-size: 7.5vw;
    }
}

.info-widget-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
}

.disclaimer{
  display: block;
  text-align: right;
  font-style: italic;
  color:gray;
}

.card-tooltip-header{
  height: 10%;
}

.stats{
  width: 100%;
}

.stats-number{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
}
</style>

<style lang="scss">
  .customTooltip {
    .tooltip-inner {
        border-radius: 16px;
        padding: 5px 10px 4px;
        text-align: left;
      }
}
</style>
